import React from "react";
import "./css/Attributions.css";

export const Attributions: React.FC = () => {
    return (
        <div className="attributions-container">
            <section className="attributions-section">
                <h2>Image Sources</h2>
                <p>
                    Sample images used within Skitterbook are sourced from{" "}
                    <a
                        href="https://www.vecteezy.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Vecteezy.com
                    </a>
                    . All rights for these images remain with their respective creators.
                </p>
            </section>

            <section className="attributions-section">
                <h2>Third‑Party Libraries & Services</h2>
                <p>Skitterbook makes use of the following third‑party components and services:</p>

                <ul className="attributions-list">
                    <li>react-bootstrap</li>
                    <li>react-dropzone</li>
                    <li>react-swipeable</li>
                    <li>Firebase</li>
                    <li>Azure Storage and Azure Web App Hosting</li>
                    <li>Neo4jClient</li>
                    <li>PDFsharp</li>
                    <li>SkiaSharp</li>
                    <li>Xabe.FFmpeg</li>
                </ul>

                <p className="attributions-note">
                    All trademarks, logos, and brand names are the property of their respective owners.
                    Their inclusion here does not imply endorsement.
                </p>
            </section>
        </div>
    );
};

export default Attributions;
